<template>
    <div class="custom_select">
        <div class="input_s" ref="states_selectbox" @click="handleStateSelectBoxClick()">
            <span class="txt">{{ selectedStatesString }}</span>
            <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
        </div>
        <div class="list multiple" ref="states_checkbox" v-show="isShow">
            <div class="item">
                <label class="check_wrap">
                    <input type="checkbox" :checked="isAllSelected" @change="updateAllCheckedState()">
                    <span class="checkmark"></span>
                    <span class="txt ellipsis">{{ $t('reservationwindow.header.label_all') }}</span>
                </label>
            </div>
            <ReservationColumnFilterItem v-for="(state, index) in states" :key="index" 
                :index="index"
                :palette="palette"
                :state="state"
                @action_SelectItem="action_SelectItem"/>
        </div>
    </div>
</template>

<script>
import { sheetState } from '../../../sheet-state'
import { sheetFilters, setStates, toggleState, toggleAllStates, selectedStates } from '../../../sheet-filters'
import ReservationColumnFilterItem from './ReservationStateFilterItem.vue'
import store from '@/store'
import { deepCopy } from '@/util/deep-copy'
import { useV2ReservationStatusListQuery } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-find-query'
export default {
    setup() {
        // 선언형 구독 — FCM/뮤테이션 invalidation 시 자동 재조회된다 (수동 워처 불필요)
        const { data: fetchedStatuses } = useV2ReservationStatusListQuery({
            hospitalID: () => store.state.hospital.selectedHospital?._id,
        })
        return { fetchedStatuses }
    },
    components: { ReservationColumnFilterItem },
    props: {
    },
    data() {
        return {
            sheetState,
            sheetFilters,

            isShow: false
        }
    },
    watch: {
        fetchedStatuses: {
            immediate: true,
            handler: function (statuses) {
                if (!statuses) { return }
                // 컨트롤러 setter 가 입력 배열을 변형(isSelected 병합·정렬)하므로 캐시 보호를 위해 복사본 전달
                setStates(deepCopy(statuses))
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleGlobalClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleGlobalClick);
    },
    computed: {
        states: function() {
            return this.sheetFilters.states
        },
        setting: function() {
            return this.sheetState.reservationSetting
        },
        palette: function() {
            return this.setting?.statusColorPaletteID?.basicPalette ?? []
        },
        isAllSelected: function() {
            return selectedStates().length == this.states.length
        },
        selectedStates: function() {
            return selectedStates()
        },
        selectedStatesString: function() {
            let count = this.selectedStates.length
            if (count == this.states.length) {
                return this.$t('reservationwindow.header.label_state_column_all')
            }
            else if (count == 0) {
                return '-'
            } else {
                let name = this.states.find(c => c._id == this.selectedStates[0]._id)?.title
                if (count > 1) {
                    name += (' 외 ' + (count - 1) + '개')
                }
                return name
            }
        },
    },
    methods: {
        handleStateSelectBoxClick() {
            this.isShow = !this.isShow
            if (!this.isShow && this.selectedStates.length == 0) {
                this.updateAllCheckedState()
            }
        },
        handleGlobalClick(event) {
            if (this.isShow) {
                if(!this.$refs.states_selectbox.contains(event.target) && !this.$refs.states_checkbox.contains(event.target)) {
                    this.handleStateSelectBoxClick()
                }
            }
        },

        updateAllCheckedState() {
            toggleAllStates(!this.isAllSelected)
        },

        action_SelectItem(index) {
            toggleState(index)
        },

    }
}
</script>